import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBookingResponse } from "../../Orchestrator/Types/Index";
import {
    IBookingRefundOffersPatchResponse,
    IBookingRefundOffersResponse,
    IBookingReleaseOffersPatchResponse,
    IBookingReleaseOffersResponse,
    IFulfillmentIdsRequest,
    IRefundOfferRequest
} from "../../Orchestrator/Types/Types/BookingTypes";

export async function bookingReleaseOffers(
    fulfillmentIds: IFulfillmentIdsRequest,
    bookingId: string
): Promise<IApiResponse<IBookingReleaseOffersResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.bookingsReleaseOffers(bookingId);

    return await apiRequest<IBookingReleaseOffersResponse>(endpoint, 'POST', {
        body: JSON.stringify(fulfillmentIds),
    });
}

export async function bookingReleaseOffersPatch(
    releaseId: string,
    bookingId: string
): Promise<IApiResponse<IBookingReleaseOffersPatchResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.bookingsReleaseOffersPatch(releaseId, bookingId);

    return await apiRequest<IBookingReleaseOffersPatchResponse>(endpoint, 'PATCH', {
        body: JSON.stringify({ "status": "CONFIRMED" }),
    });
}

export async function bookingRefundOffers(
    refundOfferRequest: IRefundOfferRequest,
    bookingId: string
): Promise<IApiResponse<IBookingRefundOffersResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.bookingsRefundOffers(bookingId);

    return await apiRequest<IBookingRefundOffersResponse>(endpoint, 'POST', {
        body: JSON.stringify(refundOfferRequest),
    });
}

export async function bookingRefundOffersPatch(
    refundId: string,
    bookingId: string
): Promise<IApiResponse<IBookingRefundOffersPatchResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.bookingsRefundOffersPatch(refundId, bookingId);

    return await apiRequest<IBookingRefundOffersPatchResponse>(endpoint, 'PATCH', {
        body: JSON.stringify({ "status": "CONFIRMED" }),
    });
}

export async function bookingCancelPaymentPost(
    bookingId: string,
    refundOfferRequest: IRefundOfferRequest,
): Promise<IApiResponse<void>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.bookingsCancelPaymentPost(bookingId);

    return await apiRequest<void>(endpoint, 'POST', {
        body: JSON.stringify(refundOfferRequest),
    });
}